import DiagnosisLineTop from 'pages/diagnosis/DiagnosisLineTop';
import DiagnosisQuestion from 'pages/diagnosis/DiagnosisQuestion';
import DiagnosisRespondentForm from 'pages/diagnosis/DiagnosisRespondentForm';
import DiagnosisResult from 'pages/diagnosis/DiagnosisResult';
import DiagnosisTop from 'pages/diagnosis/DiagnosisTop';
import Error404 from 'pages/error/Error404';
import QuizLineTop from 'pages/quiz/QuizLineTop';
import QuizQuestion from 'pages/quiz/QuizQuestion';
import QuizRespondentForm from 'pages/quiz/QuizRespondentForm';
import QuizResult from 'pages/quiz/QuizResult';
import QuizTop from 'pages/quiz/QuizTop';
import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

/**
 *　アプリケーション共通 Router定義
 */
export default function AppRoutes(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  const location = useLocation();

  useEffect(() => {
    console.log('Current location:', location.pathname);
  }, [location]);

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <Routes>
      <>
        {/* クイズ（スタート） */}
        <Route path="/quiz/:quizCd/" element={<QuizTop />} />
        {/* クイズ（回答者情報入力） */}
        <Route path="/quiz/:quizCd/form/:fieldNumber" element={<QuizRespondentForm />} />
        {/* クイズ（出題） */}
        <Route path="/quiz/:quizCd/question/:questionNumber/" element={<QuizQuestion />} />
        {/* クイズ（答え） */}
        <Route path="/quiz/:quizCd/question/:questionNumber/answer/" element={<QuizQuestion />} />
        {/* クイズ（結果） */}
        <Route path="/quiz/:quizCd/result/" element={<QuizResult />} />
        {/* クイズスタート(プレビュー) */}
        <Route path="/quiz/preview/:quizCd" element={<QuizTop preview={true} />} />
        {/* クイズスタート(LINE登録) */}
        <Route path="/quiz/line/:quizCd" element={<QuizLineTop />} />
        {/* 診断（スタート） */}
        <Route path="/diagnosis/:diagnosisCd/" element={<DiagnosisTop />} />
        {/* 診断（回答者情報入力） */}
        <Route
          path="/diagnosis/:diagnosisCd/form/:fieldNumber"
          element={<DiagnosisRespondentForm />}
        />
        {/* 診断（出題） */}
        <Route
          path="/diagnosis/:diagnosisCd/question/:questionNumber/"
          element={<DiagnosisQuestion />}
        />
        {/* 診断（結果） */}
        <Route path="/diagnosis/:diagnosisCd/result/" element={<DiagnosisResult />} />
        {/* 診断スタート(プレビュー) */}
        <Route path="/diagnosis/preview/:diagnosisCd" element={<DiagnosisTop preview={true} />} />
        {/* 診断スタート(LINE登録) */}
        <Route path="/diagnosis/line/:diagnosisCd" element={<DiagnosisLineTop />} />
        {/* 404エラー画面 */}
        <Route path="*" element={<Error404 />} />
      </>
    </Routes>
  );
}
